
import { useEffect, useState } from "react";

import { Alert, Box, Button, Card, CardActions, CardContent, CardHeader, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Snackbar, Typography } from "@mui/material"

import { LocalizationProvider, DateCalendar } from "@mui/x-date-pickers"

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment"

import moment, { Moment } from "moment";

import { LiberarAudiencia, ObtenerAudiencias, RestablecerAgenda, RestablecerLiberarAgendas } from "../../connections/comun/AgendaConnection";

import { AlertProps } from "../../interfaces/global/AlertInterface";
import { AudienciaProps } from "../../interfaces/comun/AgendaInterface";

type ActionType = 'Liberar' | 'Restablecer' | '';

const now = new Date();
const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);

const isWeekend = (date: Moment) => {
    const day = date.day();

    return day === 0 || day === 6;
};

export const AudienciasCanceladasPage = () => {

    const [open, setOpen] = useState<boolean>(false);
    const [openConfirmacion, setOpenConfirmacion] = useState<boolean>(false);

    const [action, setAction] = useState<ActionType>( '' );

    const [audiencias, setAudiencias] = useState<AudienciaProps[]>([]);
    const [evento, setEvento] = useState<AudienciaProps>();

    const [fecha, setFecha] = useState<Moment>(moment(tomorrow));

    const [loadingData, setLoadingData] = useState(true);
    const [loadingButton, setLoadingButton] = useState(false);

    const [alert, setAlert] = useState<AlertProps>({ open: false, msg: "", type: "warning" });

    const handleCloseAlert = (_: any, reason: any) => {

        if (reason === 'clickaway') {
            return;
        }

        setAlert({ open: false, type: "warning" });
    }

    const handleRestablecerLiberarAgenda = async () => {

        setLoadingButton(true)

        if ( evento?.idEstatus === 4 ) {

            await RestablecerAgenda({ idAgenda: evento?.idAgenda ?? 0 }).then(resp => {

                if ( resp.success ) {

                    setTimeout(() => {

                        setOpen(false)

                        setLoadingButton(false)

                        setAudiencias(audiencias.filter(id => id.idAgenda !== evento.idAgenda))

                        setAlert({ open: true, msg: resp.message, type: "success" })

                    }, 700);

                }
                else {

                    setLoadingButton(false)

                    setAlert({ open: true, msg: resp.message, type: "error" })

                }

            })

        }
        else if (evento?.idEstatus === 5) {

            await LiberarAudiencia({ idAgenda: evento?.idAgenda ?? 0 }).then(resp => {

                if (resp.success) {

                    setTimeout(() => {

                        setOpen(false)

                        setLoadingButton(false)

                        setAudiencias(audiencias.filter(id => id.idAgenda !== evento.idAgenda))

                        setAlert({ open: true, msg: resp.message, type: "success" })

                    }, 700);

                }
                else {

                    setLoadingButton(false)

                    setAlert({ open: true, msg: resp.message, type: "error" })

                }
            })

        }
    }

    const handleRestablecerLiberarAgendas = async () => {

        setLoadingButton( true );

        let idEstatus = 0;
        let arrayAudiencias: number[] = [];
    
        if ( action === "Liberar" ) {       
            arrayAudiencias = audiencias.filter( e => e.idEstatus === 5 ).map(a => parseInt( a.idAgenda?.toString() ?? '0' ) );
            idEstatus = 5;        
        }
        else if ( action === "Restablecer" ) {
            arrayAudiencias = audiencias.filter( e => e.idEstatus === 4 ).map(a => parseInt( a.idAgenda?.toString() ?? '0' ) );
            idEstatus = 4;        
        }

        await RestablecerLiberarAgendas({ idEstatus, agenda: arrayAudiencias }).then(resp => {

            if (resp.success) {

                setTimeout(() => {

                    setOpen(false)

                    setLoadingButton(false)

                    const arrayElements = audiencias.map(a =>  parseInt( a.idAgenda?.toString() ?? '0' ) );

                    // Filtrar los elementos que están en arr1 pero no en arr2
                    const soloEnArr1 = arrayAudiencias.filter( item => !arrayElements.includes( item ) );

                    // Filtrar los elementos que están en arr2 pero no en arr1
                    const soloEnArr2 = arrayElements.filter( item => !arrayAudiencias.includes( item ) );

                    // Unir ambos resultados
                    const noCoinciden = [...soloEnArr1, ...soloEnArr2];

                    let newArray: AudienciaProps[] = [];

                    noCoinciden.forEach( elem => {
                        const audiencia = audiencias.find( e => e.idAgenda === elem );

                        if( audiencia ){
                            newArray.push( audiencia );
                        }
                    });

                    setAudiencias( newArray )

                    setAlert({ open: true, msg: resp.message, type: "success" })

                    setOpenConfirmacion(false)

                }, 700);

            }
            else {

                setLoadingButton(false)

                setAlert({ open: true, msg: resp.message, type: "error" })

            }

        })

    }

    useEffect(() => {

        async function Obtener() {

            setAudiencias([])

            setLoadingData(true)

            await ObtenerAudiencias({ fecha: new Date( fecha.toDate() ) }).then(resp => {

                setTimeout(() => {

                    setAudiencias(resp);

                    setLoadingData(false)

                }, 700);

            });

        }

        Obtener()

    }, [fecha])

    return (

        <Grid container spacing={3}>

            {
                alert.msg
                &&
                    <Snackbar open={alert.open} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} autoHideDuration={2000} onClose={ handleCloseAlert }>
                        <Alert onClose={ () => setAlert({ open: false, type: "warning" }) } variant="filled" severity={alert.type} sx={{ width: '100%' }}>
                            {alert.msg}
                        </Alert>
                    </Snackbar>
            }

            <Grid size={{ xs: 12, md: 12 }} sx={{ mb: 2 }}>

                <Grid container spacing={3}>                   

                    <Grid size={{ xs: 12, md: 12 }} textAlign={'end'}>

                        <Button variant="contained" disabled={audiencias.filter(id => id.idEstatus === 4).length === 0 || loadingButton }  onClick={() =>{ setOpenConfirmacion(true); setAction("Restablecer") } }>
                            Restablecer todas ({audiencias.filter(id => id.idEstatus === 4).length})
                        </Button>

                    </Grid>

                    {/* 
                        <Grid size={{ xs: 12, md: 2 }} textAlign={'end'} sx={{ display: 'none' }}>

                            <Button variant="contained" disabled={audiencias.filter(id => id.idEstatus === 5  ).length === 0 || fecha < moment(now) || loadingButton}  onClick={() => { setOpenConfirmacion(true);  setAction("Liberar");}}>
                                Liberar todas ({audiencias.filter(id => id.idEstatus === 5 ).length})
                            </Button>

                        </Grid> 
                    */}

                </Grid>

            </Grid>

            <Grid size={{ xs: 12, md: 6, lg: 4 }}>

                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale='es'>
                    <DateCalendar
                        shouldDisableDate={isWeekend}
                        value={moment(fecha)}
                        onChange={(e) => setFecha(moment(e, "dd/MM/yyyy"))} />
                </LocalizationProvider>

            </Grid>

            <Grid size={{ xs: 12, md: 6, lg: 8 }}>

                {
                    audiencias.length === 0 && !loadingData
                    ?
                        <Box sx={{ height: 200 }} textAlign={'center'} alignContent={'center'}>
                            <Typography variant='body2' fontSize={14} color="textDisabled" sx={{ mt: 10 }}>
                                No se encontraron <br /> eventos
                            </Typography>
                        </Box>
                    :
                        <Grid container spacing={3} sx={{ maxHeight: 500, overflowY: 'scroll', p: 2 }}>

                            {
                                audiencias
                                .map(({ tipoAudiencia, juez, solicitante, numeroExpediente, idEstatus, idAgenda, idJuez, idSolicitante, idSecretario, secretario, duracion }, index) => (

                                    <Grid key={index} size={{ xs: 12, md: 4 }}>

                                        <Card>

                                            <CardHeader sx={{ bgcolor: '#0A192D', p: 2, color: 'white', textAlign: 'center' }} subheader={ <Typography variant="h6" fontSize={16}>{ tipoAudiencia }</Typography> } />

                                            <CardContent>

                                                <Box sx={{ p: 2, mt: -3 }}>

                                                    <Grid container spacing={1} mt={1}>
                                                        <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'}>Juez(a):</Typography> </Grid>
                                                        <Grid size={12}> <Typography variant='body2' color='black' fontSize={12}>{juez}</Typography> </Grid>
                                                    </Grid>

                                                    <Grid container spacing={1} mt={2}>
                                                        <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'}>Secretario(a):</Typography> </Grid>
                                                        <Grid size={12}> <Typography variant='body2' color='black' fontSize={12}>{secretario}</Typography> </Grid>
                                                    </Grid>

                                                    <Grid container spacing={1} mt={2}>
                                                        <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'}>Número expediente:</Typography> </Grid>
                                                        <Grid size={12}> <Typography variant='body2' color='black' fontSize={12}>{numeroExpediente}</Typography> </Grid>
                                                    </Grid>

                                                    <Grid container spacing={1} mt={2}>
                                                        <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'}>Solicitante:</Typography> </Grid>
                                                        <Grid size={12}> <Typography variant='body2' color='black' fontSize={12}>{solicitante}</Typography> </Grid>
                                                    </Grid>

                                                </Box>

                                            </CardContent>

                                            <CardActions>

                                                {
                                                    idEstatus === 4
                                                    &&
                                                        <Button 
                                                            fullWidth 
                                                            color="secondary" 
                                                            variant="outlined" 
                                                            onClick={ () => { 
                                                                setOpen( true ); 
                                                                setEvento({ 
                                                                    idAgenda: idAgenda ?? 0, 
                                                                    idEstatus: idEstatus ?? 0, 
                                                                    tipoAudiencia, 
                                                                    idJuez, 
                                                                    juez, 
                                                                    numeroExpediente, 
                                                                    solicitante, 
                                                                    idSolicitante, 
                                                                    idSecretario, 
                                                                    secretario, 
                                                                    duracion 
                                                                }); 
                                                            }} 
                                                        >
                                                            Restablecer
                                                        </Button>
                                                }

                                                {
                                                    ( idEstatus === 5 && fecha > moment( now ) )
                                                    &&
                                                        <Button 
                                                            fullWidth 
                                                            variant="contained" 
                                                            onClick={ () => { 
                                                                setOpen( true ); 
                                                                setEvento({ 
                                                                    idAgenda: idAgenda ?? 0, 
                                                                    idEstatus: idEstatus ?? 0, 
                                                                    tipoAudiencia, 
                                                                    idJuez, 
                                                                    juez, 
                                                                    numeroExpediente, 
                                                                    solicitante, 
                                                                    idSolicitante, 
                                                                    idSecretario, 
                                                                    secretario, 
                                                                    duracion 
                                                                }); 
                                                            }} 
                                                        >
                                                            Liberar
                                                        </Button>
                                                }

                                            </CardActions>

                                        </Card>

                                    </Grid>

                                ))
                            }

                        </Grid>
                }

                {
                    loadingData
                    &&
                        <Grid size={12} textAlign={'center'} alignContent={'center'} height={250}>
                            <CircularProgress size={32} />
                        </Grid>
                }

            </Grid>

            <Dialog open={open} onClose={() => { }} >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>
                        { evento?.idEstatus === 5 && '¿Desea liberar la audiencia seleccionada?' }
                        { evento?.idEstatus === 4 && '¿Desea restablecer la audiencia seleccionada?' }
                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button
                        color='secondary' 
                        onClick={() => setOpen(false)}
                        disabled={loadingButton}
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant='contained'
                        color='primary'
                        onClick={() => handleRestablecerLiberarAgenda()}
                        loading={loadingButton}
                    >
                        Aceptar
                    </Button>

                </DialogActions>

            </Dialog>

            <Dialog open={openConfirmacion} onClose={() => { }} >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>
                        ¿Desea <strong>{ action.toLowerCase() }</strong> todas las audiencias { action === "Liberar" ? "agendadas" : "canceladas" }?
                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button
                        color='secondary' 
                        onClick={() => setOpenConfirmacion(false)}
                        disabled={loadingButton}
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant='contained'
                        color='primary'
                        onClick={ () => handleRestablecerLiberarAgendas() }
                        loading={loadingButton}
                    >
                        Aceptar
                    </Button>

                </DialogActions>

            </Dialog>

        </Grid>
    )
}
